import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { ReactComponent as Lock } from 'assets/icons/lock.svg'
import { ReactComponent as Notification } from 'assets/icons/notification.svg'

import { createOrderStatus, getOrderStatus, updateOrderStatus } from '../redux/actions'
import { OrderStatus as OrderStatusOpts } from '../redux/types'

const initialState = {
  order: 0,
  color: '#EBEBEB',
  icon: '',
  name: '',
  alias: '',
  staffMessage: '',
  clientMessage: '',
  roles: ['OWNER'] as unknown as OrderStatusOpts['roles']
}
const OrderStatus: React.FC = () => {
  const history = useHistory()
  const dispatch = useDispatch()

  const { id } = useParams<{ id: string }>()
  const [form, setForm] = useState(initialState)
  const [isFetching, setFetching] = useState(false)

  function handleClear (): void {
    setForm(initialState)
    history.push('/panel/order/status')
  }

  async function handleSubmit (e: React.FormEvent): Promise<void> {
    e.preventDefault()
    try {
      setFetching(true)
      if (!id) {
        await createOrderStatus(form)(dispatch).then(res => {
          if (res?.status) {
            handleClear()
          }
        })
      } else {
        await updateOrderStatus(id, form)(dispatch)
      }
      setFetching(false)
    } catch (error) {
      alert(error.message)
    }
  }

  function isRoleChecked (role: OrderStatusOpts['roles'][0]): boolean {
    return !!form.roles.find(item => item === role)
  }

  function handleRole (role: OrderStatusOpts['roles'][0]): void {
    const index = form.roles.findIndex(item => item === role)
    if (index > -1) {
      setForm({
        ...form,
        roles: [
          ...form.roles.slice(0, index),
          ...form.roles.slice(index + 1)
        ]
      })
    } else {
      setForm({ ...form, roles: [...form.roles, role] })
    }
  }

  useEffect(() => {
    if (id) {
      getOrderStatus(id)(dispatch).then(res => {
        const cardStatus = res?.data
        if (res?.status === 'success' && cardStatus) {
          setForm({
            order: cardStatus.order,
            color: cardStatus.color,
            icon: cardStatus.icon,
            name: cardStatus.name,
            alias: cardStatus.alias,
            staffMessage: cardStatus.staffMessage,
            clientMessage: cardStatus.clientMessage,
            roles: cardStatus.roles || []
          })
        }
      })
    } else {
      handleClear()
    }
    // eslint-disable-next-line
  }, [id, dispatch])

  return (
    <form className="row" onSubmit={handleSubmit}>

      <div className="row panel margin-top-16">
        <div className="row justify-start">
          <h2 className="row justify-start">
            <Notification height="25" width="35" fill="var(--panel-text)" /> Gestão de Status
          </h2>
        </div>

        <div className="row justify-start">
          <div className="row" style={{ display: 'grid', gridTemplateColumns: '100px 200px 80px 1fr 3fr' }}>
            <div className="form-control">
              <label>Cor</label>
              <input
                type="color"
                value={form.color}
                onChange={({ target: { value } }): void => setForm(form => ({ ...form, color: value }))}
                required
              />
            </div>
            <div className="form-control">
              <label>Ícone</label>
              <input
                type="text"
                value={form.icon}
                onChange={({ target: { value } }): void => setForm(form => ({ ...form, icon: value }))}
                required
              />
            </div>
            <div className="form-control">
              <label>Ordem</label>
              <input
                type="number"
                value={form.order}
                step={1}
                onChange={({ target: { value } }): void => setForm(form => ({ ...form, order: parseInt(value) }))}
                required
              />
            </div>
            <div className="form-control">
              <label>Status</label>
              <input
                type="text"
                value={form.name}
                onChange={({ target: { value } }): void => setForm(form => ({ ...form, name: value.toUpperCase() }))}
                required
              />
            </div>
            <div className="form-control">
              <label>Apelido do Status</label>
              <input
                type="text"
                value={form.alias}
                onChange={({ target: { value } }): void => setForm(form => ({ ...form, alias: value }))}
                required
              />
            </div>
          </div>

          <div className="form-control">
            <label>Mensagem Colaborador</label>
            <input
              type="text"
              value={form.staffMessage}
              onChange={({ target: { value } }): void => setForm(form => ({ ...form, staffMessage: value }))}
            />
          </div>
          <div className="form-control">
            <label>Mensagem Cliente</label>
            <input
              type="text"
              value={form.clientMessage}
              onChange={({ target: { value } }): void => setForm(form => ({ ...form, clientMessage: value }))}
            />
          </div>
        </div>
      </div>

      <div className="row panel margin-top-32">
        <div className="row justify-start">
          <h2 className="row justify-start">
            <Lock height="25" width="30" fill="var(--panel-text)" /> Permissões
          </h2>
        </div>
        <p>Permissões que o colaborador poderá alterar</p>

        <div className="row justify-start margin-top-16">
          <label className="checkbox">
            <input
              readOnly
              type="checkbox"
              checked={isRoleChecked('OWNER')}
              onClick={(): void => handleRole('OWNER')}
            />
            <span className="checkmark"/> Proprietário
          </label>
          <label className="checkbox">
            <input
              readOnly
              type="checkbox"
              checked={isRoleChecked('MANAGER')}
              onClick={(): void => handleRole('MANAGER')}
            />
            <span className="checkmark"/> Gerente
          </label>
          <label className="checkbox">
            <input
              readOnly
              type="checkbox"
              checked={isRoleChecked('CLERK')}
              onClick={(): void => handleRole('CLERK')}
            />
            <span className="checkmark"/> Atendente
          </label>
          <label className="checkbox">
            <input
              readOnly
              type="checkbox"
              checked={isRoleChecked('COOKER')}
              onClick={(): void => handleRole('COOKER')}
            />
            <span className="checkmark"/> Cozinheiro
          </label>
          <label className="checkbox">
            <input
              readOnly
              type="checkbox"
              checked={isRoleChecked('DELIVERYMAN')}
              onClick={(): void => handleRole('DELIVERYMAN')}
            />
            <span className="checkmark"/> Entregador
          </label>
        </div>
      </div>

      <div className="row justify-end margin-top-16">
        <span className="button secondary" onClick={handleClear} style={{ width: 300 }}>
          Limpar
        </span>
        <button className="button primary margin-left-8" style={{ width: 300 }}>
          { isFetching ? 'Processando...' : (id ? 'Atualizar' : 'Cadastrar') }
        </button>
      </div>
    </form>
  )
}

export default OrderStatus
